"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEBefestigungsvariante = void 0;
var AEBefestigungsvariante;
(function (AEBefestigungsvariante) {
    AEBefestigungsvariante["A"] = "A";
    AEBefestigungsvariante["A1"] = "A1";
    AEBefestigungsvariante["A2"] = "A2";
    AEBefestigungsvariante["A3"] = "A3";
    AEBefestigungsvariante["A4"] = "A4";
    AEBefestigungsvariante["C2"] = "C2";
})(AEBefestigungsvariante = exports.AEBefestigungsvariante || (exports.AEBefestigungsvariante = {}));
//# sourceMappingURL=AEBefestigungsvariante.js.map